module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('Top-bar', {
    attrs: {
      "domain": _vm.domainName,
      "domain-info": _vm.domainInfo
    }
  }), _vm._v(" "), _c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "90"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0077a0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/job_list.vue
// module id = 1440
// module chunks = 1